import Sidebar from "components/elements/Sidebar";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import "animate.css";
import toast, { Toaster } from "react-hot-toast";
import { useEffect, useState } from "react";
import dataProvider from "./DataProvider";
const App = props => {
  const [notifications, setNotifications] = useState([]);

  const location = useLocation();
  const permissions = props.menuPermissions;

  useEffect(() => {
    if (props.token.client_id) {
      fetchNotifications();
    }
  }, []);

  // if (!props.token.client_type) {
  let firstMenuPath = permissions.length
    ? permissions[0].pathname
    : "/dashboard";

  // check if current page is allowed based on menu permission we built
  let isAllowed = false;
  for (let i = 0; i < permissions.length; i++) {
    if (location.pathname.includes(permissions[i].pathname)) {
      isAllowed = true;
      break;
    }
  }

  // if not allowed on current page then send to first allowed menu
  if (!isAllowed && !location.pathname.includes(firstMenuPath)) {
    return <Navigate to={firstMenuPath} replace />;
  }

  // On allowed pages, if submenu is there then redirect to that submenu's first page
  for (let i = 0; i < permissions.length; i++) {
    if (location.pathname.includes(permissions[i].pathname)) {
      if (permissions[i].subMenus.length) {
        // now redirect to first sub menu page if current location does not match any of allowed sub menus
        let matched = false;
        for (let j = 0; j < permissions[i].subMenus.length; j++) {
          if (permissions[i].subMenus[j].pathname.includes(location.pathname)) {
            matched = true;
            break;
          }
        }
        if (!matched) {
          return <Navigate to={permissions[i].subMenus[0].pathname} replace />;
        }
      }
    }
  }
  // }

  const fetchNotifications = async () => {
    try {
      const notifications = await dataProvider.network.get("get-notification");

      // consumption alert notifications
      let cn = [];
      // const percent = 50;
      const percent = props.token.consumption_alert_percent;
      const consumption_limit = props.token.spots * (percent / 100);
      if (props.token.consumed_spots >= consumption_limit) {
        cn.push({
          title: "Alert",
          description: "You are approaching your Spot Limit", //`Your spot consumption (${props.token.consumed_spots}) has exceeded ${percent}% of total spots (${props.token.spots})`,
        });
      }

      setNotifications([...cn, ...notifications]);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load notifications");
    }
  };

  return (
    <div id="app">
      <Toaster />
      <Sidebar {...props} />
      <div id="container">
        {notifications.length > 0 && (
          <div className="notification-wrapper">
            {notifications.map((notif, index) => (
              <div key={index} className="notification">
                <p>
                  {notif.title} : {notif.description}
                </p>
              </div>
            ))}
          </div>
        )}
        <Outlet context={props} />
      </div>
    </div>
  );
};

export default App;
